import { Box, Typography } from '@mui/material';
import { type ModalActions, ModalContainer } from 'src/components/ModalContainer';
import { type ConfirmationRequest, useConfirmationStore } from 'src/store/confirmation-modal';

export const CONFIRMATION_MODAL_BODY_PORTAL_ID = 'confirmation-modal-body-portal';

const getActions = (
  request: ConfirmationRequest,
  settle: (value: boolean) => void,
): ModalActions => {
  if (request.kind === 'alert') {
    return [
      {
        label: request.acknowledgeLabel,
        kind: 'primary',
        onClick: () => settle(true),
        testId: 'confirmation-modal-ok',
      },
    ];
  }

  return [
    {
      label: request.cancelLabel ?? 'Cancel',
      kind: 'secondary',
      onClick: () => settle(false),
      testId: 'confirmation-modal-cancel',
    },
    {
      label: request.confirmLabel,
      kind: request.danger ? 'danger' : 'primary',
      onClick: () => settle(true),
      testId: 'confirmation-modal-confirm',
    },
  ];
};

export const ConfirmationModal = () => {
  const { isOpen, request, settleConfirmation } = useConfirmationStore();

  if (!request) {
    return null;
  }

  return (
    <ModalContainer
      open={isOpen}
      size="small"
      draggable={false}
      title={request.title}
      titleTestId="confirmation-modal-title"
      actions={getActions(request, settleConfirmation)}
      onClose={() => settleConfirmation(false)}
      data-testid="confirmation-modal"
    >
      <Typography variant="body2">{request.body}</Typography>
      <Box id={CONFIRMATION_MODAL_BODY_PORTAL_ID} />
    </ModalContainer>
  );
};
